import { useState } from 'react'
import { isValidEmail } from '../../utils/validationScripts'
import { Button, FormControl, FormLabel, Input, Text, Textarea } from '@chakra-ui/react'
import emailjs from '@emailjs/browser'

const ContactUsForm = (props) => {
  emailjs.init('W2ccMnigxVFU0FxLX')
  const { setEmailSent } = props;
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  const formMesage = "Have an idea for a game? Want to report a bug? Something else? Send us a message!"

  const buttonIsDisabled = name === '' || email === '' || !isValidEmail(email) || message === '' || message.length < 10

  const submit = () => {
    if (name && email && message) {
      const serviceId = 'service_1om6vcq'
      const templateId = 'template_rix01lb'
      const templateParams = {
        name,
        email,
        message
      }

      emailjs.send(serviceId, templateId, templateParams)
        .then(response => {
          setName('')
          setEmail('')
          setMessage('')
          setEmailSent(true)
        })
        .catch(error => console.log(error))
    }
  }
  return (
    <>
      <Text textAlign="center" mb={6} p={4} fontSize="lg">{formMesage}</Text>
      <FormControl isRequired>
        <FormLabel>Your name</FormLabel><Input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </FormControl>
      <FormControl isRequired mt={4}>
        <FormLabel>Email address</FormLabel>
        <Input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </FormControl>
      <FormControl isRequired mt={4}>
        <FormLabel>Your message</FormLabel>
        <Textarea
          placeholder="Your message"
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
      </FormControl>
      <Button onClick={submit} mt={4} mb={4} isDisabled={buttonIsDisabled}>Send Message</Button>
    </>
  )
}

export default ContactUsForm
